import React from 'react';
import AccessKey from '../../components/accesskey';

const AccessKeyContainer = () => <AccessKey />;

export default AccessKeyContainer;
